/* eslint-disable */
import * as React from "react";
import { last, first } from "lodash";
import { ReportToolbar, ReportToolbarGroup, ReportToolbarSpacer, ReportToolbarNumber } from "../../components/ReportToolbar";
import { ReportGrid } from "../../components/ReportGrid";
import { ReportLayout } from "../../components/ReportLayout";
import { ReportHeader } from "../../components/ReportHeader";
import { ReportContainer } from "../../components/ReportContainer";
import { ReportRenderer, useParameter } from "../../shared";
import { useSlideSubtitle } from "./hooks/useSlideSubtitle";
import { useSlideTitle } from "./hooks/useSlideTitle";
import { useDescription } from "./hooks/useDescription";
import { useExportQuery } from "./export/useExportQuery";
import { useFavourite } from "./favourite/useFavourite";
import { useSubscription } from "./subscription/useSubscription";
import { SLIDE_NUMBER } from "./constants";
import { CalendarHierarchyControl } from "./controls/CalendarHierarchyControl";
import { CommoditiesControl } from "./controls/CommoditiesControl";

export default function Slide18(props: { exportMode?: boolean }) {
  const { exportMode } = props;

  const title = useSlideTitle();
  const subtitle = useSlideSubtitle();
  const description = useDescription();

  useExportQuery(title, subtitle);
  useFavourite();
  useSubscription();

  return (
    <ReportContainer>
      <ReportHeader title={title} subtitle={subtitle} description={description} exportMode={exportMode} />
      <ReportToolbar exportMode={exportMode}>
        <ReportToolbarGroup>
          <CalendarHierarchyControl />
          <CommoditiesControl />
        </ReportToolbarGroup>
        <ReportToolbarSpacer />
        <ReportToolbarNumber number={SLIDE_NUMBER} />
      </ReportToolbar>
      <ReportLayout>
        <ReportGrid>
          <ReportRenderer componentId="chart" />
        </ReportGrid>
      </ReportLayout>
    </ReportContainer>
  );
}
